import React from 'react';
import { useParams } from 'react-router-dom';
import iParamTypes from '../../../../../../types/iParamTypes';
import iProduct from '../../../../../../types/product/iProduct';
import ProdSellSos from './ProdSellSOs';
import { SpaceVerticalContainer } from '../../../../../../shared/styles/styles';
import CCPProdContComp from '../../../../../../shared/CCPProductContactCompany/CCPProdContComp';

function ProdSell({ product, isDisabled }: { product?: iProduct; isDisabled?: boolean }) {
  const { id } = useParams<iParamTypes>();
  const productId = product?.id || id;

  return (
    <>
      <CCPProdContComp
        startFieldId={id}
        fixedProduct={product}
        isCustomer
        canCreate={!isDisabled}
        canUpdate={!isDisabled}
        canDelete={!isDisabled}
      />
      <SpaceVerticalContainer className={'five'} />
      <ProdSellSos productId={productId} />
    </>
  );
}

export default ProdSell;
